import { Paginated } from "@/pagination";
import Entity from "../entity";

export default class Submission {
  id: number;
  content: SubmissionContent[];
  entity: Entity | null = null;
  entityDocumentationId: number;
  entityDepartmentId: number;
  enabled: boolean;
  createdAt: Date;
  constructor(
    id: number,
    content: SubmissionContent[],
    entityDocumentationId: number,
    entityDepartmentId: number,
    createdAt: Date,
    enabled = true
  ) {
    this.id = id;
    this.createdAt = createdAt;
    this.enabled = enabled;
    this.content = content;
    this.entityDocumentationId = entityDocumentationId;
    this.entityDepartmentId = entityDepartmentId;
  }
}

export type SubmissionKind = "table" | "file" | "iframe" | "rich-text";

export interface Content {
  readonly discriminant?: string;
  readonly kind: SubmissionKind;
}

export type SubmissionContent =
  | TableContent<unknown>
  | FileContent
  | IFrameContent
  | CommentContent;

type Source<T> = (page: number, filter?: string, all?: boolean) => Promise<Paginated<T>>;


export class TableContent<T> implements Content {
  readonly kind = "table";
  public discriminant?: string;
  definition: TableDefinition;
  dataSource: Source<T>;
  total: number;
  exportLink?: string;
  dataLink?: string;
  features: Array<"filter" | "sort">
  constructor(
    definition: TableDefinition,
    dataSource: Source<T>,
    total: number,
    features: Array<"filter" | "sort">,
    exportLink?: string,
    dataLink?: string,
  ) {
    this.definition = definition;
    this.dataSource = dataSource;
    this.total = total;
    this.exportLink = exportLink;
    this.dataLink = dataLink;
    this.features = features;
  }

}

export function isTableContent<T>(obj: Content): obj is TableContent<T> {
  return obj.kind == "table";
}

export type FileType = "pdf" | "unknown";
export class FileContent implements Content {
  readonly kind = "file";
  fileType: FileType = "unknown";
  filename: string;
  downloadLink: string;

  constructor(link: string, filename: string, fileType?: FileType) {
    this.filename = filename;
    this.downloadLink = link;
    if (fileType) {
      this.fileType = fileType;
    }
  }
}

export function isFileContent(obj: Content): obj is FileContent {
  return obj.kind == "file";
}

export class IFrameContent implements Content {
  readonly kind = "iframe";
  title: string;
  iFrameLink: string;

  constructor(link: string, title: string) {
    this.title = title;
    this.iFrameLink = link;
  }
}

export function isIFrameContent(obj: Content): obj is IFrameContent {
  return obj.kind == "iframe";
}

export class CommentContent implements Content {
  readonly kind = "rich-text";
  text: string;

  constructor(text: string) {
    this.text = text;
  }
}

export function isCommentContent(obj: Content): obj is CommentContent {
  return obj.kind == "rich-text";
}

export interface TableDefinition {
  columns: ColumnDefinition[];
}

export interface SimpleColumn {
  name: string;
}

export interface TypedColumn {
  name: string;
  type: string;
}
export type ColumnDefinition = SimpleColumn | TypedColumn;

export function isTypedColumn(obj: ColumnDefinition): obj is TypedColumn {
  return (obj as TypedColumn).type !== undefined;
}
